// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__z-7nf","modalQuestionWrapper":"styles_modalQuestionWrapper__0wMTq"};